module.exports = __webpack_public_path__ + "static/media/etamine_logo.0538cadf.jpg";